(() => {
  class LCCarouselNavigation {
    constructor(component) {
      this.component = component;
      this.stage = component.querySelector('.lc-carousel-stage');
      this.slider = component.querySelector('[id^="Slider-"]');
      this.media = component.querySelector('.slider__slide .card__inner');
      this.zones = component.querySelectorAll('.lc-carousel-zone');
      this.zoneCleanups = [];

      if (!this.stage || !this.slider || !this.media) return;

      this.update = this.update.bind(this);
      this.scheduleUpdate = this.scheduleUpdate.bind(this);
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
      this.resizeObserver.observe(this.stage);
      this.resizeObserver.observe(this.media);
      this.zones.forEach((zone) => this.enableTouchSwipe(zone));
      window.addEventListener('load', this.scheduleUpdate, { once: true });
      this.scheduleUpdate();
    }

    enableTouchSwipe(zone) {
      const state = {
        active: false,
        dragged: false,
        ignoreClick: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        startScrollLeft: 0,
      };

      const onPointerDown = (event) => {
        if (event.pointerType === 'mouse') return;
        state.active = true;
        state.dragged = false;
        state.pointerId = event.pointerId;
        state.startX = event.clientX;
        state.startY = event.clientY;
        state.startScrollLeft = this.slider.scrollLeft;
      };

      const onPointerMove = (event) => {
        if (!state.active || event.pointerId !== state.pointerId) return;

        const distanceX = event.clientX - state.startX;
        const distanceY = event.clientY - state.startY;

        if (!state.dragged && Math.abs(distanceX) > 8 && Math.abs(distanceX) > Math.abs(distanceY)) {
          state.dragged = true;
        }

        if (!state.dragged) return;
        event.preventDefault();
        this.slider.scrollLeft = state.startScrollLeft - distanceX;
      };

      const finishGesture = () => {
        if (state.dragged) {
          state.ignoreClick = true;
          window.setTimeout(() => {
            state.ignoreClick = false;
          }, 400);
        }

        state.active = false;
        state.pointerId = null;
      };

      const onClickCapture = (event) => {
        if (!state.ignoreClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        state.ignoreClick = false;
      };

      zone.addEventListener('pointerdown', onPointerDown);
      zone.addEventListener('pointermove', onPointerMove);
      zone.addEventListener('pointerup', finishGesture);
      zone.addEventListener('pointercancel', finishGesture);
      zone.addEventListener('click', onClickCapture, true);

      this.zoneCleanups.push(() => {
        zone.removeEventListener('pointerdown', onPointerDown);
        zone.removeEventListener('pointermove', onPointerMove);
        zone.removeEventListener('pointerup', finishGesture);
        zone.removeEventListener('pointercancel', finishGesture);
        zone.removeEventListener('click', onClickCapture, true);
      });
    }

    scheduleUpdate() {
      window.cancelAnimationFrame(this.frame);
      this.frame = window.requestAnimationFrame(this.update);
    }

    update() {
      const stageRect = this.stage.getBoundingClientRect();
      const mediaRect = this.media.getBoundingClientRect();

      if (mediaRect.height <= 0) return;

      const mediaTop = Math.max(0, mediaRect.top - stageRect.top);
      this.stage.style.setProperty('--lc-carousel-media-top', `${mediaTop}px`);
      this.stage.style.setProperty('--lc-carousel-media-height', `${mediaRect.height}px`);
      this.stage.dataset.lcNavigationReady = 'true';
    }

    destroy() {
      window.cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.zoneCleanups.forEach((cleanup) => cleanup());
    }
  }

  const initialize = (root = document) => {
    const components = [];

    if (root.matches?.('[data-lc-carousel-navigation]')) components.push(root);
    components.push(...root.querySelectorAll('[data-lc-carousel-navigation]'));

    components.forEach((component) => {
      if (component.lcCarouselNavigation) return;
      component.lcCarouselNavigation = new LCCarouselNavigation(component);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-lc-carousel-navigation]').forEach((component) => {
      component.lcCarouselNavigation?.destroy();
    });
  });
})();
